/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import useOutsideClick from 'client/src/utils/useOutsideClick';
import { useHistory } from 'react-router';
import { getNotifications } from './notifyList';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

import styles from './styles.module.css';

type NotifyPropsType = {
  id: number,
  title: string,
  message: string,
  callback: () => void,
  show: boolean
};

const Notifications = (): React.Element<'div'> => {
  const history = useHistory();
  const context = React.useContext(DefaultContainerContext);
  const ref = React.useRef(null);
  const [isShowTooltip, handleShowTooltip] = React.useState(false);
  const [notifications, setNotifications] = React.useState(getNotifications(context, history));
  const [unread, setUnread] = React.useState(0);

  React.useEffect(() => {
    setUnread(notifications.filter((x: any): any => x.show).length);
  }, [notifications]);

  useOutsideClick(ref, () => {
    handleShowTooltip(false);
  });

  const handleClickNotification = (item: any) => {
    item.callback();
    setNotificationSeen(item.id);
    handleShowTooltip(false);
  };

  const setNotificationSeen = (id: number) => {
    let arr;

    try {
      arr = JSON.parse(localStorage.getItem('seenNotifications'));
      if (!arr) throw new Error();
    } catch (e) {
      arr = [];
      console.log(e);
    }
    arr.push(id);
    localStorage.setItem('seenNotifications', JSON.stringify([...new Set(arr)]));

    setNotifications(notifications.map((el: any): any => {
      if (el.id === id) {
        return {
          ...el,
          show: false
        };
      }
      return el;
    }));
  };

  return (
    <div
      onClick={(): void => unread > 0 && handleShowTooltip(!isShowTooltip)}
      className={`${styles.container} ${isShowTooltip ? styles.isActive : ''}`} ref={ref}
    >
      <div>
        <span className={styles.icon}>
          <i className="icon icon-bell" />
          {unread > 0 && <span className={styles.badge}>{unread}</span>}
        </span>
        <span className={styles.title}>Notifications</span>
      </div>
      {isShowTooltip && (
        <div className={styles.tooltip}>
          <ul className={styles.list}>
            {_.map(notifications, (item: NotifyPropsType, key: number): React.Element => {
              if (item.show) {
                return (
                  <li key={key} onClick={(): void => handleClickNotification(item)}>
                    <p><b>{item.title}:</b> <span>{item.message}</span></p>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Notifications;
